
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesGiftVoucherDialog extends Common.GridEditorDialog<POSSalesGiftVoucherRow> {
        protected getFormKey() { return POSSalesGiftVoucherForm.formKey; }
        //protected getIdProperty() { return POSSalesGiftVoucherRow.idProperty; }
        protected getLocalTextPrefix() { return POSSalesGiftVoucherRow.localTextPrefix; }
        //protected getNameProperty() { return POSSalesGiftVoucherRow.nameProperty; }
        //protected getService() { return POSSalesGiftVoucherService.baseUrl; }
        //protected getDeletePermission() { return POSSalesGiftVoucherRow.deletePermission; }
        //protected getInsertPermission() { return POSSalesGiftVoucherRow.insertPermission; }
        //protected getUpdatePermission() { return POSSalesGiftVoucherRow.updatePermission; }

        protected form = new POSSalesGiftVoucherForm(this.idPrefix);
      //  protected editor = new POSSalesGiftVoucherEditor(this.);
        constructor() {
            super();
            this.form.GiftMasterId.changeSelect2(e => {

                var giftdetails = OMS.GiftVoucherMasterRow.getLookup().itemById[this.form.GiftMasterId.value];
                this.form.Value.value = giftdetails.Value;
                this.form.Amount.value = giftdetails.Value;
                this.form.IsPartial.value = giftdetails.PartialRedeem;
                let now = new Date();
                now.setMonth(now.getMonth() + giftdetails.Validity)
                this.form.Expiry.set_value(now.toLocaleDateString());

                POSSalesDialog.giftcheck = true;

            });
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.GiftMasterId.value != "") {
                var giftdetails = OMS.GiftVoucherMasterRow.getLookup().itemById[this.form.GiftMasterId.value];
                this.form.Value.value = giftdetails.Value;
                this.form.Amount.value = giftdetails.Value;
                this.form.IsPartial.value = giftdetails.PartialRedeem;
                let now = new Date();
                now.setMonth(now.getMonth() + giftdetails.Validity)
                this.form.Expiry.set_value(now.toLocaleDateString());

                POSSalesDialog.giftcheck = true;
            } else {
                POSSalesDialog.giftcheck = false;
            }
        }
        //protected getToolbarButtons(): Serenity.ToolButton[] {
        //    let buttons = super.getToolbarButtons();

        //    var btnAdd = Q.first(buttons, x => x.cssClass == "save-and-close-button");
        //    var oldAddClick = btnAdd.onClick;

        //    btnAdd.onClick = e => { this.AddEvent(oldAddClick, e); };



        //    return buttons;
        //}
        //private AddEvent(oldEvt, e) {
        //    //let now = new Date();
        //    //var dt = now.getDay();
        //    //var mt = now.getMonth();
        //    //var yr = now.getUTCFullYear();
        //    //var hr = now.getUTCHours();
        //    //var mn = now.getUTCMinutes();
        //    //var sc = now.getUTCSeconds();
        //    //var msc = now.getUTCMilliseconds() - 1;

        //    //var id = this.nextId;
        //    //var temp = dt.toString() + mt.toString() + yr.toString() + hr.toString() + mn.toString() + sc.toString() + "" + msc.toString() + "";

        //    //if (this.form.Quantity.value > 1) {
        //    //    for (var i = 0; i < this.form.Quantity.value; i++) {
        //            let now = new Date();
        //            var dt = now.getDay();
        //            var mt = now.getMonth();
        //            var yr = now.getUTCFullYear();
        //            var hr = now.getUTCHours();
        //            var mn = now.getUTCMinutes();
        //            var sc = now.getUTCSeconds();
        //            var msc = now.getUTCMilliseconds();


        //            var temp = dt.toString() + mt.toString() + yr.toString() + hr.toString() + mn.toString() + sc.toString() + "" + msc.toString() + "";

        //            var currentrow: POSSalesGiftVoucherRow = {
        //                UniqueCode: temp,
        //                Amount: this.form.Amount.value,
        //                Expiry: this.form.Expiry.value
        //            };

        //            // var id = row.Quantity;
        //            //      id = id + 1;
        //            currentrow[this.getIdProperty()] = 1;
        //            this.editor.view.addItem(currentrow);
        //    //    }
        //    //}

        //    //row[this.getIdProperty()] = id++;
        //    //this.view.addItem(row);
            
        //    this.dialogClose();
        //}
    }

}